import React from 'react';
import Router from './components/router';

function App() {
  return(
    <div> 
      <Router /> 
    </div>
  );
};

export default App;